<template>
  <div class="UXpagingInp">
    <div class="pagInput" :class="{noBorder:!isShowSize}">
      <v-btn flat icon @click="beforePage"><i class="UXicon-arrow_left"></i></v-btn>
      <input v-model="pagCount" class="inpPag" type="number" :disabled="isDisabled" @change="changePage"/> / {{ length }}
      <v-btn flat icon @click="nextPage"><i class="UXicon-arrow_right"></i></v-btn>
    </div>
    <div class="pagSelect" v-show="isShowSize">
      <v-select
        v-model="size"
        :items="pagList"
        auto-select-first="true"
        class="UXselect"
        color="#6D8DFF"
        hide-details
        outline
        solo
        no-data-text="データがありません。"
      >
      </v-select>
    </div>
    <input type="hidden" v-model="value" />
  </div>
</template>

<script>
export default {
  name: 'inpPagination',
  props: {
    value: {
      type: Number,
      required: false
    },
    length: {
      type: Number,
      required: false
    },
    isShowSize: {
      type: Boolean,
      required: false,
      default: true
    },
    pageSize: {
      type: Number,
      required: false,
      default: 5
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    pagList: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      pagCount: 0,
      size: this.pageSize,
      maxPaging: 0,
      init: false
    }
  },
  watch: {
    size () {
      if (this.length) {
        this.$emit('input', {
          pag: 1,
          size: this.size
        })
      }
    },
    value: {
      immediate: true,
      handler (val) {
        this.pagCount = val
        this.init = val ? String(val).replace(/[^0-9]/g, '') : 1
      }
    },
    length (val) {
      try {
        this.init = val
        this.pagCount = val ? 1 : 0
      } catch (e) {
        console.log(e)
      }
    }
  },
  computed: {
    isDisabled () {
      return this.length === 0
    }
  },
  methods: {
    changePage () {
      if (Number(this.pagCount) <= 0 || Number(this.pagCount) > this.length) {
        return
      }
      this.$emit('input', {
        pag: Number(this.pagCount),
        size: this.size
      })
    },
    nextPage () {
      if (this.length === 0 || this.pagCount >= this.length) {
        return false
      }
      this.pagCount = Number(this.pagCount) + 1
      this.$emit('input', {
        pag: this.pagCount,
        size: this.size
      })
    },
    beforePage () {
      if (this.length === 0 || this.pagCount <= 1) {
        return false
      }
      this.pagCount = Number(this.pagCount) - 1
      this.$emit('input', {
        pag: this.pagCount,
        size: this.size
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InpPagination.vue